///////////////////////////////////////////////////////////////////////////////////////
//                          Copyright (c) 2021 - 2021
//                           Coyote Logistics L.L.C.
//                         All Rights Reserved Worldwide
//
//WARNING:  This program (or document) is unpublished, proprietary
//property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
//Unauthorized reproduction, distribution or disclosure of this program
//(or document), or any program (or document) derived from it is
//prohibited by State and Federal law, and by local law outside of the U.S.
///////////////////////////////////////////////////////////////////////////////////////

import React from "react";
import { useSelector, useDispatch } from "react-redux";

import messages from "../../helpers/messages";
import {
  saveNotificationSettings,
  toggleSaveSettingErrorModal
} from "../../slices/notificationsSlice";
import NotificationSettingRow from "./NotificationSettingRow";
import SystemErrorModal from "../SystemErrorModal";

export const NotificationSettings = () => {
  const dispatch = useDispatch();
  const { settings, saveSettingError } = useSelector(
    state => state.notifications
  ).settings;
  const allSelected = {
    email: settings.every(({ email }) => email),
    browser: settings.every(({ browser }) => browser)
  };

  const handleSelectAll = settingName => () => {
    dispatch(
      saveNotificationSettings(
        settings
          .filter(s => s[settingName] === allSelected[settingName])
          .map(setting => ({
            ...setting,
            [settingName]: !allSelected[settingName]
          }))
      )
    );
  };
  const handleTryAgain = () =>
    dispatch(
      saveNotificationSettings(
        settings
          .filter(
            s => s.unSavedBrowser !== undefined || s.unSavedEmail !== undefined
          )
          .map(s => ({
            ...s,
            email: s.unSavedEmail,
            browser: s.unSavedBrowser
          }))
      )
    );

  return (
    <div className="py-16 page-width settings">
      <SystemErrorModal
        open={saveSettingError}
        handleExit={() => dispatch(toggleSaveSettingErrorModal(false))}
        handleTryAgain={handleTryAgain}
      />
      <h1 data-testid="settings">
        {messages.notificationSettings.defaultMessage}
      </h1>
      <table className="card display-table one-whole">
        <thead>
          <tr className="row">
            <th className="one-half py-16 pl-28">
              {messages.event.defaultMessage}
            </th>
            <th className="one-quarter py-16 pos-relative">
              <input
                className="pointer pos-absolute mt-2"
                type="checkbox"
                checked={allSelected.email}
                onChange={handleSelectAll("email")}
                disabled={settings.some(s => s.unSavedEmail !== undefined)}
              />
              <span className="pl-28">{messages.email.defaultMessage}</span>
            </th>
            <th className="one-quarter py-16 pos-relative">
              <input
                className="pointer pos-absolute mt-2"
                type="checkbox"
                checked={allSelected.browser}
                onChange={handleSelectAll("browser")}
                disabled={settings.some(s => s.unSavedBrowser !== undefined)}
              />
              <span className="pl-28">{messages.browser.defaultMessage}</span>
            </th>
          </tr>
        </thead>
        <tbody>
          {settings.map(setting => (
            <NotificationSettingRow
              key={"notification-type-" + setting.notificationSettingId}
              {...setting}
            />
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default NotificationSettings;
